import { GameWinLineCelebrationProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameWinLineCelebrationProperties";
export class WinLineCelebrationLandscapeProperties extends GameWinLineCelebrationProperties {
    constructor() {
        super();
        this.scale.set(0.73);
        this.position.set(608, 98);
    }
}
//# sourceMappingURL=WinLineCelebrationLandscapeProperties.js.map